/**
 * ค่าเริ่มต้นสีกำหนดเอง — ต้องตรงกับ kepttam-admin-backend app/Constants/DefaultCompanyCustomColor.js
 */
export const DEFAULT_COMPANY_CUSTOM_COLOR = {
  background_color: "#FFEB3B",
  button_color: "#D32F2F",
  button_text_color: "#FFFFFF",
};
